import React from "react";
import { classNames } from "../../utils/helpers";
import PropTypes from "prop-types";

const OptionLabelsSelector = (props) => {
  const { onChange, value, options = [], multiple = false } = props;

  const isSelected = (itemValue) => {
    if (multiple) {
      return Array.isArray(value) && value.includes(itemValue);
    }
    return value === itemValue;
  };

  return (
    <div
      className="px-4 py-2 bg-gray-100 rounded-lg flex items-center gap-2
    
    
    "
    >
      {options.map((item, index) => (
        <button
          key={index}
          type="button"
          className={classNames(
            "flex-1 text-center py-2 px-4 rounded-md cursor-pointer text-sm font-medium text-slate-600 border-none",
            {
              "bg-white shadow-sm text-gray-700": isSelected(item.value),
            },
          )}
          onClick={() => onChange(item.value)}
        >
          {item.label}
        </button>
      ))}
    </div>
  );
};

OptionLabelsSelector.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string,
    PropTypes.number,
  ]),
  multiple: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.string,
        PropTypes.number,
      ]),
    }),
  ),
};

export default OptionLabelsSelector;
